// NOTE: リングタイマー（残り時間リング）の時間計算ロジック

export const computeRemainingSeconds = (expireAt, now) => {
  if (!expireAt) return null

  return Math.floor((Date.parse(expireAt) - now.getTime()) / 1000)
}

// NOTE: 残り時間の割合（1=開始直後、0=終了）。リングの描画量に使う
export const computeRingRatio = (startAt, expireAt, now) => {
  if (!(startAt && expireAt)) return 0

  const totalSeconds = (Date.parse(expireAt) - Date.parse(startAt)) / 1000
  if (totalSeconds <= 0) return 0

  const remainingSeconds = (Date.parse(expireAt) - now.getTime()) / 1000
  const ratio = remainingSeconds / totalSeconds

  return Math.min(Math.max(ratio, 0), 1)
}

// NOTE: 1時間以上は「時:分:秒」、1時間未満は「分:秒」、超過は「+」付き
// （「1:57」が1分57秒か1時間57分か紛らわしいため、1時間以上は桁数で区別する）
export const formatRemainingLabel = remainingSeconds => {
  if (remainingSeconds === null || remainingSeconds === undefined) return ''

  const sign = remainingSeconds < 0 ? '+' : ''
  const absSeconds = Math.abs(remainingSeconds)

  const seconds = absSeconds % 60

  if (absSeconds >= 3600) {
    const hours = Math.floor(absSeconds / 3600)
    const minutes = Math.floor((absSeconds % 3600) / 60)

    return `${sign}${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }

  const minutes = Math.floor(absSeconds / 60)

  return `${sign}${minutes}:${String(seconds).padStart(2, '0')}`
}

export default () => {
  return {
    computeRemainingSeconds,
    computeRingRatio,
    formatRemainingLabel,
  }
}
